<template>
  <neb-card :imageSrc="asset.thumbnail_url || brandDefaultPreviewImage || require('@assets/images/image-icon.png')"
    :imageInfo="durationInfo"
    class="organizeAssetCardVideo"
    :title="asset.title || 'No title'"
    width="305px"
    height="325px"
  >
    <template v-slot:imageOverlay>
      <div class="organizeAssetCardVideo-viewOverlay">
        <router-link :to="detailRoute"
          target="_blank"
          rel="noopener noreferrer"
        >
          <neb-button type="primary"
            :captureClicks="false"
          >
            View Content
          </neb-button>
        </router-link>
      </div>

      <div class="organizeAssetCardVideo-select"
        v-show="selectable"
      >
        <neb-checkbox :value="selected"
          @click.native="onCheckboxInput"
        ></neb-checkbox>
      </div>
    </template>

    <template v-slot:footer>
      <div class="organizeAssetCardVideo-source">
        <div class="organizeAssetCardVideo-source-image">
          <img :src="sourceImageUrl"
            width="32px"
            height="32px"
            alt="Brand Image"
          >
        </div>

        <div class="organizeAssetCardVideo-source-url">
          <a :href="asset.url"
            title="View Source"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ humanizedSourceUrl }}
          </a>
        </div>

        <div class="organizeAssetCardVideo-source-date">
          <span>{{ displayDate }}</span>
        </div>
      </div>
    </template>
  </neb-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'OrganizeAssetCard',

  props: {
    asset: {
      type: Object,
      required: true
    },
    selectable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      required: true
    }
  },

  computed: {
    durationInfo () {
      const {
        word_count = '--',
        duration = 0
      } = this.asset

      let formatDuration = '--'

      if (duration !== 0) {
        formatDuration = moment.duration(duration, 'seconds')
          .humanize()
      }

      return `${formatDuration} to read | ${word_count} words`
    },
    detailRoute ()  {
      return {
        name: 'assetDetail',
        params: {
          brandName: this.$route.params.brandName,
          pageUrlId: this.asset.page_url_id
        }
      }
    },
    sourceImageUrl () {
      switch (this.asset.data_provider) {
        case 'nativo_advertiser': return require('../../assets/images/nativo_icon_square.png')
        default: return this.$store.getters.squareLogoUrl(this.asset.brand_ids)
      }
    },
    brandDefaultPreviewImage () {
      return this.$store.state.brand.settings.defaultPreviewImage
    },
    humanizedSourceUrl () {
      const { url } = this.asset

      return url.length > 32
        ? `${url.substring(0, 32)}...`
        : url
    },
    displayDate () {
      const { created_at } = this.asset

      return moment(created_at)
        .format('MMM Do, YYYY')
    }
  },

  methods: {
    onCheckboxInput (e) {
      if (e.shiftKey) {
        this.$emit('shiftSelect', this.index)
      } else {
        this.$emit('select', this.index)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../Nebula/style.scss';

.organizeAssetCardVideo {
  &-viewOverlay {
    box-sizing: border-box;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0, 0.4);
    opacity: 0;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }

  &-select {
    box-sizing: border-box;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    padding: 14px;
  }

  &-source {
    box-sizing: border-box;
    overflow: hidden;
    display: grid;
    grid-template-columns: 15% auto;
    grid-template-rows: auto auto;
    padding-top: 4px;

    &-image,
    &-url,
    &-date {
      box-sizing: border-box;
      overflow: hidden;
    }

    &-image {
      grid-column: 1 / span 1;
      grid-row: 1 / span 2;
    }

    &-url {
      grid-column: 2 / span 1;
      grid-row: 1 / span 1;

      a {
        text-decoration: none;
        font-family: $defaultFont;
        color: $cool-blue;
        font-size: 12px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
      }
    }

    &-date {
      grid-column: 2 / span 1;
      grid-row: 2 / span 1;

      span {
        font-family: $defaultFont;
        font-size: 12px;
        font-weight: 300;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: $slate-grey;
      }
    }
  }
}
</style>
